export const INTERCOM_LAUNCHER_CLASSNAME = "intercomLauncher";
